import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronDown, CheckCircle2 } from 'lucide-react';
import { MingaIcon } from './MingaLogo';
export function Hero() {
  return <section className="pt-28 pb-20 md:pt-36 md:pb-24 px-6 bg-white overflow-hidden" data-id="element-87">
      <div className="max-w-6xl mx-auto" data-id="element-88">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-89">
          {/* Left — Text */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-90">
            <span className="inline-block py-1 px-3 rounded-full bg-gray-100 text-gray-600 text-xs font-medium mb-5" data-id="element-91">
              Representación exclusiva para compradores
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-gray-900 mb-5 leading-[1.15]" data-id="element-92">
              Comprar una propiedad es caro.{' '}
              <span className="text-brand-600" data-id="element-93">
                Pagar 2% de comisión es carísimo.
              </span>
            </h1>

            <p className="text-base text-gray-600 mb-7 leading-relaxed max-w-lg" data-id="element-94">
              MINGA es la primera empresa donde solo trabajamos para el
              comprador, para que tomen una mejor decisión, con una tarifa fija
              y sin conflictos de interés
            </p>

            <div className="flex flex-col items-start gap-2 mb-8" data-id="element-95">
              {['No trabajamos para venderte una propiedad', 'Trabajamos para que compres bien', 'Nuestro incentivo está alineado contigo'].map(text => <div key={text} className="flex items-center gap-2 text-gray-700" data-id="element-96">
                  <CheckCircle2 size={16} className="text-brand-600 shrink-0" data-id="element-97" />
                  <span className="text-sm font-medium" data-id="element-98">{text}</span>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row items-start gap-3" data-id="element-99">
              <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-brand-600 hover:bg-brand-700 text-white px-7 py-3 rounded-full font-medium transition-all text-sm" data-id="element-100">
                Quiero comprar mejor
              </button>
              <button className="w-full sm:w-auto flex items-center justify-center gap-2 text-gray-500 hover:text-gray-700 px-5 py-3 rounded-full font-medium transition-colors text-sm" data-id="element-101">
                Ver cómo funciona
                <ChevronDown size={16} data-id="element-102" />
              </button>
            </div>
          </motion.div>

          {/* Right — Image with logo */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="relative flex items-center justify-center" data-id="element-103">
            {/* Image */}
            <div className="relative w-full aspect-square max-w-md mx-auto rounded-3xl overflow-hidden" data-id="element-104">
              <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80" alt="Propiedad moderna" className="w-full h-full object-cover" data-id="element-105" />
              <div className="absolute inset-0 bg-gray-900/10" data-id="element-106" />

              {/* Logo overlay */}
              <div className="absolute top-6 left-6 z-10" data-id="element-107">
                <MingaIcon size={48} data-id="element-108" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}